import { RCS_PROVIDERS } from "../../../../utils/constant";

const { KARIX } = RCS_PROVIDERS;

export const getRcsAssignedRoutesMutation = (builder) => ({
  getRcsAssignedRoutes: builder.mutation({
    query: ({ page = 1, limit = "", status = "", search = "", provider = KARIX,    startDate,
      endDate, }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/rcs_assigned_routes",
        method: "GET",
        params: {
          page,
          limit,
          status,
          search,
          provider,
          startDate,
          endDate,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
